export const VENUE_CATEGORIES = [
  "Turf", "Pickleball", "Swimming Pool", "Snooker", "Pool Club", "Gym",
  "Basketball", "PlayStation", "Yoga", "Golf Club", "Table Tennis", "Kabaddi",
  "Badminton", "Archery", "Zumba Classes", "Shooting", "Hockey (Indoor/Outdoor)",
  "Squash", "Skating (Ice/Roller)", "Tennis", "Football/ Soccer", "Baseball",
  "Volleyball (Indoor/Beach)", "Karate", "Boxing", "Taekwondo", "Sky Martial Arts",
  "Chess Academy", "Dance Academy", "Horse Riding", "Bowling", "Rock Climbing",
  "Go-karting", "Other Sports",
] as const;

export const COACH_TRAINER_CATEGORIES = [
  "Cricket", "Pickleball", "Swimming Pool", "Snooker", "Pool Club", "Gym",
  "Basketball", "PlayStation", "Yoga", "Golf Club", "Table Tennis", "Kabaddi",
  "Badminton", "Archery", "Zumba Classes", "Shooting", "Hockey (Indoor/Outdoor)",
  "Squash", "Skating (Ice/Roller)", "Tennis", "Football/ Soccer", "Baseball",
  "Volleyball (Indoor/Beach)", "Karate", "Boxing", "Taekwondo", "Sky Martial Arts",
  "Chess Academy", "Dance Academy", "Horse Riding", "Bowling", "Rock Climbing",
  "Go-karting", "Other Sports",
] as const;

export const COACH_TRAINER_CATEGORY_OPTIONS = COACH_TRAINER_CATEGORIES.map((category) => ({
  value: category,
  label: category,
}));

export const resolveCoachTrainerCategory = (slugOrName?: string): string | undefined => {
  if (!slugOrName) return undefined;
  const clean = slugOrName.toLowerCase().trim();
  if (clean === "other-sports" || clean === "other sports" || clean === "othersports") return "Other Sports";

  // Check direct match against full name or slug
  const directMatch = COACH_TRAINER_CATEGORIES.find(
    (cat) => cat.toLowerCase() === clean || toCategorySlug(cat) === clean
  );
  if (directMatch) return directMatch;

  // Common aliases and shortcuts
  const aliasMap: Record<string, string> = {
    "cricket": "Cricket",
    "cricket-coach": "Cricket",
    "cricket-trainer": "Cricket",
    "football": "Football/ Soccer",
    "soccer": "Football/ Soccer",
    "football-soccer": "Football/ Soccer",
    "swimming": "Swimming Pool",
    "swimming-pool": "Swimming Pool",
    "pool": "Pool Club",
    "pool-club": "Pool Club",
    "snooker": "Snooker",
    "gym": "Gym",
    "fitness": "Gym",
    "yoga": "Yoga",
    "badminton": "Badminton",
    "tennis": "Tennis",
    "table-tennis": "Table Tennis",
    "tabletennis": "Table Tennis",
    "pickleball": "Pickleball",
    "basketball": "Basketball",
    "volleyball": "Volleyball (Indoor/Beach)",
    "volleyball-indoorbeach": "Volleyball (Indoor/Beach)",
    "hockey": "Hockey (Indoor/Outdoor)",
    "hockey-indooroutdoor": "Hockey (Indoor/Outdoor)",
    "skating": "Skating (Ice/Roller)",
    "skating-iceroller": "Skating (Ice/Roller)",
    "dance": "Dance Academy",
    "dance-academy": "Dance Academy",
    "chess": "Chess Academy",
    "chess-academy": "Chess Academy",
    "martial-arts": "Sky Martial Arts",
    "martialarts": "Sky Martial Arts",
    "sky-martial-arts": "Sky Martial Arts",
    "boxing": "Boxing",
    "karate": "Karate",
    "taekwondo": "Taekwondo",
    "zumba": "Zumba Classes",
    "zumba-classes": "Zumba Classes",
    "golf": "Golf Club",
    "golf-club": "Golf Club",
    "squash": "Squash",
    "archery": "Archery",
    "shooting": "Shooting",
    "horse-riding": "Horse Riding",
    "bowling": "Bowling",
    "rock-climbing": "Rock Climbing",
    "go-karting": "Go-karting",
    "kabaddi": "Kabaddi",
    "playstation": "PlayStation",
    "baseball": "Baseball",
  };

  if (aliasMap[clean]) return aliasMap[clean];

  return undefined;
};

export const isValidCoachTrainerCategorySlug = (slug?: string): boolean => {
  if (!slug) return false;
  const clean = slug.toLowerCase().trim();
  if (clean === "all" || clean === "other-sports") return true;
  return Boolean(resolveCoachTrainerCategory(clean));
};


export const toCategorySlug = (name: string) => {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/[\s_-]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

export const isValidVenueCategorySlug = (slug?: string): boolean => {
  if (!slug) return false;
  const clean = slug.toLowerCase().trim();
  if (clean === "all" || clean === "other-sports") return true;

  const validSet = new Set<string>();

  // Add all VENUE_CATEGORIES and their generated slugs
  VENUE_CATEGORIES.forEach((cat) => {
    validSet.add(cat.toLowerCase());
    validSet.add(toCategorySlug(cat));
  });

  // Common aliases, shorthand names and historical URLs
  const aliases = [
    "turf",
    "cricket",
    "cricket-turf",
    "cricket-turfs",
    "cricket-ground",
    "cricket-grounds",
    "football",
    "soccer",
    "football-soccer",
    "football-grounds",
    "swimming",
    "pool",
    "dance",
    "fitness",
    "skating",
    "volleyball",
    "hockey",
    "badminton-court",
    "tennis-court",
    "box-cricket",
  ];
  aliases.forEach((alias) => {
    validSet.add(alias);
    validSet.add(toCategorySlug(alias));
  });

  return validSet.has(clean) || validSet.has(toCategorySlug(clean));
};
